// Phase A.2.a canonical 17-value CRM relationship role vocabulary.
//
// SOURCE OF TRUTH: /app/backend/core/relationship_roles.py
// Frontend must offer only these values on new writes / role changes.
// Historic rows carrying legacy vocabulary MUST still display — see
// `roleLabel()` for the permissive-read fallback.

export const CANONICAL_ROLES = [
  ["artist_principal", "Artist / Principal"],
  ["tour_manager", "Tour Manager"],
  ["production_manager", "Production Manager"],
  ["business_manager", "Business Manager"],
  ["personal_manager", "Personal Manager"],
  ["road_manager", "Road Manager"],
  ["transportation_coordinator", "Transportation Coordinator"],
  ["accountant", "Accountant"],
  ["accounts_payable", "Accounts Payable"],
  ["booking_agent", "Booking Agent"],
  ["agent", "Agent"],
  ["manager", "Manager"],
  ["assistant", "Assistant"],
  ["security", "Security"],
  ["vendor_contact", "Vendor Contact"],
  ["driver_liaison", "Driver Liaison"],
  ["other", "Other"],
];

export const CANONICAL_ROLE_KEYS = new Set(CANONICAL_ROLES.map(([k]) => k));

export const isCanonicalRole = (role) =>
  typeof role === "string" && CANONICAL_ROLE_KEYS.has(role);

export const roleLabel = (role) => {
  const hit = CANONICAL_ROLES.find(([k]) => k === role);
  if (hit) return hit[1];
  if (!role) return "—";
  // Permissive-read: historical values still render, humanised.
  return String(role)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
